<template>
  <div
    v-if="article.title"
    class="space-y-4 md:space-y-6"
  >
    <div class="relative -z-10 pt-12 md:z-0 md:pt-9">
      <div class="card-base card-round absolute inset-0 -bottom-20 overflow-hidden bg-purple md:bottom-[20%] md:mx-4">
        <patterns-wood
          preserveAspectRatio="none"
          class="absolute inset-x-0 top-2/3 w-full fill-violet"
        />
      </div>

      <div class="container">
        <NuxtLink
          to="/nieuws"
          class="relative hidden md:mb-9 md:flex md:items-center md:text-white"
        >
          <div class="mr-2 flex size-7 items-center justify-center rounded-[42%] border border-white">
            <IconsArrowLeft class="stroke-white" />
          </div>
          Terug naar overzicht
        </NuxtLink>

        <BaseCard class="card-base relative flex items-center gap-4 p-6 max-sm:flex-col md:gap-10 md:p-10 lg:p-10">
          <div
            class="space-y-6"
            :class="{'md:w-3/12': article.active_image}"
          >
            <span class="text-xs md:text-sm">{{ formatDate(article.created_at) }}</span>
            <h1 class="!mt-2 text-xl font-semibold md:text-4xl md:font-medium">
              {{ article.title }}
            </h1>
            <NuxtPicture
              v-if="article.active_image"
              :img-attrs="{class: 'aspect-[3/2] rounded-2xl object-cover md:hidden'}"
              :src="article.active_image.url"
              :alt="article.title"
              sizes="400px md:800px lg:1600px"
            />
            <template v-if="article.employeeName && article.employeeOccupation && article.employeePortrait">
              <NuxtPicture
                :img-attrs="{class: 'mask aspect-1 w-1/2 max-w-[192px] bg-yellow object-contain'}"
                :src="article.employeePortrait?.url"
                :alt="article.employeeName"
              />
              <div class="text-sm font-semibold md:text-xl">
                {{ article.employeeName }}
              </div>
              <div class="!mt-1 text-sm md:text-lg">
                {{ article.employeeOccupation }}
              </div>
            </template>
          </div>

          <div
            v-if="article.active_image?.url"
            class="relative h-full w-9/12 max-sm:hidden"
          >
            <NuxtPicture
              :img-attrs="{class: 'aspect-[1.8] h-full w-full rounded-2xl object-cover'}"
              :src="article.active_image.url"
              :alt="article.title"
              sizes="400px md:800px lg:1600px"
            />
            <span
              v-if="article.active_image.title"
              class="card-base absolute bottom-6 right-6 rounded-lg px-6 py-3 text-violet"
            >
              {{ article.active_image.title }}
            </span>
          </div>
        </BaseCard>
      </div>
    </div>

    <div class="container">
      <BaseCard class="card-base space-y-6 bg-offWhite p-6 md:p-20">
        <SofieText
          class="prose max-w-none gap-8 lg:columns-2"
          :value="article.text"
        />
        <!--        <SocialLinksContainer class="pt-2 md:pt-8" />-->
      </BaseCard>
    </div>
  </div>
</template>

<script setup lang="ts">
import {useArticleQuery} from '~/graphql/graphql';
import {formatDate} from '~/libs/date';

definePageMeta({
  header: {
    transparent: true,
  },
  bg: 'bg-white',
});

const route = useRoute();

const {result} = useArticleQuery({slug: route.params.slug});
const article = computed(() => result.value?.article[0] ?? {});

// TODO: handle SEO en 404
// useSeo(article.value.title, article.value.seo || {} as Seo);
</script>
